module.exports = __webpack_public_path__ + "static/img/QRcode.618b993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/QRcode.png
// module id = 37ZR
// module chunks = 9